import './careers.css';
import React from 'react';

const JoinAutzu = () => {
  return (
    <div className="greyframe">
      <div className="join-container">
        <div className="innerbox">
          <div className="header">Job openings</div>
          <p className="join-textcenter">
            Join the team at Autzu and be a part of the future of
            drivesharing.
          </p>
          <button
            onClick={() =>
              window.open(
                'https://www.linkedin.com/company/autzu/mycompany/'
              )
            }>
            Job openings
          </button>
        </div>
      </div>
    </div>
  );
};

export default JoinAutzu;



// WEBPACK FOOTER //
// ./src/components/Careers/JoinAutzu.js